import { fabric } from "fabric";


export function applyWatermarkOverlay(canvas, watermarkUrl,saveCanvasState) {
return new Promise( (res,rej) => {
  try{


  if (!canvas) return;

  
  

  console.log("fabcanvas objects",canvas
    .getObjects("image"), canvas._objects)
// debugger
  fabric.Image.fromURL(
    watermarkUrl,
    (img) => {
      const baseScaleX = canvas.getWidth() / img.width;
      const baseScaleY = canvas.getHeight() / img.height;

      img.set({
        originX: "left",
        originY: "top",
        left: 0,
        top: 0,
        opacity: 0.3,

       
        selectable: false,
        evented: false,
        hasControls: false,
        hasBorders: false,
        hoverCursor: "default",
     
        
        lockMovementX: true,
        lockMovementY: true,
        lockRotation: true,
        lockScalingX: true,
        lockScalingY: true,
        lockUniScaling: true,

        
        scaleX: baseScaleX,
        scaleY: baseScaleY,
      });

    
      img.data = { isWatermark: true };

     
      img.watermarkBaseScaleX = baseScaleX;
      img.watermarkBaseScaleY = baseScaleY;
      const existing = canvas
      .getObjects("image")
      .find((obj) => obj.data?.isWatermark);
      
    if (existing) {
     res(existing ) ;
     return;
    }
      canvas.add(img);
      canvas.bringToFront(img);
      canvas.renderAll();
      // debugger
     
      res(img)
    },
    { crossOrigin: "anonymous" }
  );
}
catch (err){
rej(err)
debugger
}

} )

 
}